import { render, staticRenderFns } from "./DataFilters.vue?vue&type=template&id=60bdcc05&scoped=true&"
import script from "./DataFilters.vue?vue&type=script&lang=js&"
export * from "./DataFilters.vue?vue&type=script&lang=js&"
import style0 from "./DataFilters.vue?vue&type=style&index=0&id=60bdcc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdcc05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
